import { render, staticRenderFns } from "./platformTaskImport.vue?vue&type=template&id=4c8ec2fb&scoped=true"
import script from "./platformTaskImport.vue?vue&type=script&lang=js"
export * from "./platformTaskImport.vue?vue&type=script&lang=js"
import style0 from "./platformTaskImport.vue?vue&type=style&index=0&id=4c8ec2fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ec2fb",
  null
  
)

export default component.exports